//判断是否是iOS WKWebview内核
const base = {
  // 微信的appID
  // wxAppId: null,
  regExp: {
    telReg: /^1\d{10}$/,
    imgReg: /<img(.*?)>/g,
    voiceReg: /<div class='voice'(.*?)<\/div>/g,
    pwdReg: /^[\@A-Za-z0-9\!\#\$\%\^\&\*\.\~]{4,22}$/,
  },
  // 判断是否是在移动设备
  isMobile: (function() {
    const ua = navigator.userAgent.toLowerCase();
    
    // 基本的移动设备检测
    const basicMobile = /android|webos|iphone|ipod|blackberry/i.test(ua);
    
    // 鸿蒙系统的精确检测
    const isHarmonyMobile = /harmonyos|harmony|openharmony/i.test(ua) && 
                           (/mobile/i.test(ua) || 
                            /phone/i.test(ua) || 
                            window.innerWidth <= 768 ||
                            'ontouchstart' in window);
    
    return basicMobile || isHarmonyMobile;
  })(),
  // 是否安卓设备
  isAndroid: /android/gi.test(navigator.appVersion),
  // 是否IOS设备
  isIos: /(iPhone|iPad|iPod|iOS)/gi.test(navigator.userAgent),
  // 是否鸿蒙设备（包括手机、平板、电脑等所有鸿蒙设备）
  isHarmony: /HarmonyOS|Harmony|OpenHarmony/i.test(navigator.userAgent),

  //判断是否是iOS WKWebview内核
  isWKWebview: window.__wxjs_is_wkwebview,

  isIDevice: /iphone|ipad/gi.test(navigator.appVersion),
  isTouchPad: /hp-tablet/gi.test(navigator.appVersion),

  weekMap: ['周日', '周一', '周二', '周三', '周四', '周五', '周六'],
  weekDays: ['', '周一', '周二','周三','周四','周五','周六','周日'],
};

base.iosVersion = (function() {
  if (!base.isIDevice) return;

  let version,
    ua = navigator.userAgent,
    ipad = ua.match(/(iPad).*OS\s([\d_]+)/),
    iphone = !ipad && ua.match(/(iPhone\sOS)\s([\d_]+)/);

  if (iphone) version = iphone[2].replace(/_/g, '.');

  if (ipad) version = ipad[2].replace(/_/g, '.');

  // IOS设备完整系统版本号
  base.iosFullVersion = version;

  if (version && ua.indexOf('.') >= 0) {
    version = version.split('.')[0] * 1;
  }
  return version;
})();
base.compareVersion =(function(v1, v2) {
  v1 = v1.split('.');
  v2 = v2.split('.');
  var len = Math.max(v1.length, v2.length);
  while (v1.length < len) {
      v1.push('0');
  }
  while (v2.length < len) {
      v2.push('0');
  }
  for (var i = 0; i < len; i++) {
      var num1 = parseInt(v1[i], 10);
      var num2 = parseInt(v2[i], 10);
      if (num1 > num2) {
          return 1;
      }
      if (num1 < num2) {
          return -1;
      }
  }
  return 0;
});

// 所属产品线
base.productType = '';
// 提供给业务系统，以用于标识当前产品环境。
base.setProductType = function(string) {
  base.productType = string;
};

/**
 * 当前宿主环境标识
 * 微信小程序：wxxcx
 * 企业微信： wxwork
 * 微信： wx
 * 钉钉: dd
 * 校管家app: xgj
 * 普通浏览器环境: browser
 */
base.env = (function() {
  // navigator.userAgent 属性包含了浏览器类型、版本、操作系统类型、浏览器引擎类型等信息
  var ua = window.navigator.userAgent.toLowerCase();

  // 模拟云校app的ua
  // ua = "Mozilla/5.0 (Linux; Android 10; VCE-AL00 Build/HUAWEIVCE-AL00; wv) AppleWebKit/537.36 (KHTML, like Gecko) Version/4.0 Chrome/77.0.3865.120 MQQBrowser/6.2 TBS/045613 Mobile Safari/537.36 xgj/cs/1.0"

  if (ua.match(/MicroMessenger/i)) {
    if (ua.match(/miniprogram/i)) {
      return 'wxxcx';
    } else if (ua.match(/wxwork/i)) {
      return 'wxwork';
    } else {
      return 'wx';
    }
  } else if (ua.match(/dingtalk/i)) {
    return 'dd';
  } else if (ua.match(/lftapp/i) || ua.match(/xgj/i)) {
    if (ua.match(/wkwebview/i)) {
      base.isWKWebview = true;
    }
    return 'xgj';
  } else {
    return 'browser';
  }
})();

// 加载相应环境SDK成功的promise, 最好在该promise成功后再启动vue的spa应用
base.getEnvSDKPromise = (function() {
  const config = {
    browser: 'https://res.wx.qq.com/open/js/jweixin-1.6.0.js',
    wx: 'https://res.wx.qq.com/open/js/jweixin-1.6.0.js',
    wxxcx: 'https://res.wx.qq.com/open/js/jweixin-1.3.2.js',
    wxwork: 'https://res.wx.qq.com/open/js/jweixin-1.2.0.js',
    dd: 'https://cdn01.xiaogj.com/uploads/fe/libs/official/dingtalk/1.9.0/dingtalk.js',
    // dd: "https://g.alicdn.com/dingding/dingtalk-jsapi/2.0.72/dingtalk.open.js",
    xgj: 'https://xgj.js',
  };

  return new Promise((resolve, reject) => {
    if (base.env === 'xgj') {
      resolve(base.env);
    } else {
      var script = document.createElement('script');
      script.type = 'text/javascript';
      // 加载相应环境JS-SDK
      script.src = config[base.env];

      script.onload = script.onerror = function(a) {
        // console.log(a);
        resolve(base.env);
      };

      window.document.head.appendChild(script);
    }
  });
})();

export default base;
